import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=66c9f590&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=66c9f590&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9f590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c9f590')) {
      api.createRecord('66c9f590', component.options)
    } else {
      api.reload('66c9f590', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=66c9f590&scoped=true", function () {
      api.rerender('66c9f590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/layout/Index.vue"
export default component.exports